import { toastError } from "../toast";

//tempo de vida da URL temporaria do blob apos a aba ja ter carregado o arquivo
const TEMPO_PARA_LIBERAR_BLOB = 60000;

//a aba aberta com window.open("") herda a origem da aplicacao, entao navegar para um
//esquema como javascript: ou data: executaria script no contexto do sistema
const urlDeArquivoValida = (url: string) => {
  try {
    const protocolo = new URL(url, window.location.href).protocol;
    return protocolo === "http:" || protocolo === "https:";
  } catch {
    return false;
  }
};

const nomeDoArquivo = (url: string) => {
  try {
    return decodeURIComponent(new URL(url, window.location.href).pathname.split("/").pop() ?? "") || "Documento";
  } catch {
    return "Documento";
  }
};

const PAGINA_DE_CARREGAMENTO = `
  <html>
    <head></head>
    <body style="margin:0; display:flex; align-items:center; justify-content:center; height:100vh; font-family:'Inter', sans-serif; color:#334155;">
      Carregando o documento...
    </body>
  </html>
`;

export const openPdfInNewTab = async (url: string) => {
  if (!url || !urlDeArquivoValida(url)) {
    toastError("Arquivo não encontrado ou com endereço inválido.");
    return;
  }

  //a aba precisa ser aberta de forma sincrona, ainda dentro do clique do usuario,
  //senao o bloqueador de pop-up do navegador cancela a abertura
  const newTab = window.open("", "_blank");

  if (!newTab) {
    toastError("Não foi possível abrir o arquivo. Libere os pop-ups deste site no navegador e tente novamente.");
    return;
  }

  newTab.document.write(PAGINA_DE_CARREGAMENTO);
  newTab.document.close();
  //atribuido pelo DOM, e nao interpolado no HTML, para que o nome do arquivo enviado
  //pelo usuario seja sempre tratado como texto
  newTab.document.title = nomeDoArquivo(url);

  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Falha ao baixar o arquivo (HTTP ${response.status})`);
    }

    //o visualizador de PDF do Chrome nao renderiza data: URI (fica em branco) e ainda estoura
    //o limite de tamanho em documentos escaneados — blob: é renderizado normalmente.
    //o tipo é fixado em application/pdf: o blob herda a origem da aplicacao, entao um
    //Content-Type inesperado vindo do bucket nao pode virar HTML executavel
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));

    newTab.location.href = blobUrl;

    setTimeout(() => URL.revokeObjectURL(blobUrl), TEMPO_PARA_LIBERAR_BLOB);
  } catch (error) {
    //rede indisponivel ou CORS bloqueado no bucket: navega direto para a URL do arquivo,
    //que o navegador consegue exibir sozinho por ser um arquivo publico
    newTab.location.href = url;
  }
};
